export default __webpack_public_path__ + "static/media/08-min.280d4c95.jpg";